import type { PianoPageConfig } from './entities/PianoPageConfig';
import {
  type PagesPianoConfigPage,
  PianoExperiencePageType,
  PianoPaywallPageType,
  type PianoPageType,
  PaywallExemptTags,
} from '@/app_lib/types/piano/Paywall';
import type { Page } from '@/main/entities/content/articles/Post';
import type { Company } from '@/main/entities/content/Company';

function setPianoTags(
  pageType: PianoPageType,
  sectionNames: string[],
  topicNames: string[],
  tagNames: string[],
  premiumCategory: string,
): string[] {
  const formattedSectionNames = sectionNames.map((section) => `S-${section}`);
  const formattedTopicNames = topicNames.map((topic) => `TO-${topic}`);
  const formattedTagNames = tagNames.map((tag) => `TA-${tag}`);
  const formattedPremiumCategory = premiumCategory ? `PC-${premiumCategory}` : '';
  const formattedPageType = `PageType-${pageType}`;

  return [
    formattedPageType,
    ...formattedSectionNames,
    ...formattedTopicNames,
    ...formattedTagNames,
    formattedPremiumCategory,
  ];
}

const defaultPianoPageConfig: PianoPageConfig = {
  contentSection: '',
  pageType: PianoExperiencePageType.Default,
  publishDate: '',
  pianoTags: ['PageType-Default'],
};

const pageTypeAsContentSectionPages = [
  PianoPaywallPageType.Ranking,
  PianoPaywallPageType.Company,
  PianoPaywallPageType.People,
];

export function setPianoConfig(page: PagesPianoConfigPage): PianoPageConfig {
  const { pageType, pageData } = page;
  if (pageType === PianoExperiencePageType.Default) {
    return defaultPianoPageConfig;
  }
  const { dateGmt, premiumCategory, primarySection, sectionNames, tagNames, topicNames } = pageData as Page;

  const pianoTags = setPianoTags(pageType, sectionNames, topicNames, tagNames, premiumCategory.name);
  const contentSection = pageTypeAsContentSectionPages.includes(pageType as PianoPaywallPageType)
    ? (pageType as PianoPaywallPageType)
    : primarySection.name;

  // This is to enable turning off the paywall for companies where that exception is set in the CMS
  if (pageType === PianoPaywallPageType.Company && !(pageData as Company).hasPaywall) {
    pianoTags.push(PaywallExemptTags.Bypass);
  }

  return {
    contentSection,
    pageType,
    publishDate: dateGmt,
    pianoTags,
  };
}
